import React, {useContext} from "react";
import "./Footer.scss";
import {Fade} from "react-reveal";
import emoji from "react-easy-emoji";
import StyleContext from "../../contexts/StyleContext";

export default function Footer() {
  return (
    <div className="footer-text">
      © 2026 Harsh Gulia | AI Automation Developer
    </div>
  );
}
